"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadStatusBar = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var connected_react_router_1 = require("connected-react-router");
var react_transition_group_1 = require("react-transition-group");
var fileUploadModal_1 = require("actions/fileUploadModal");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Types = require("types");
var sok_ui_1 = require("@caddigital/sok-ui");
var utils = require("utils/helpers/fileUpload");
var formatSize_1 = require("utils/helpers/formatSize");
require("./styles.scss");
var totalUploadSize = function (total) {
    var suffix = ['Bytes', 'Kb', 'Mb', 'Gb', 'Tb'][Math.floor(Math.log(total) / Math.log(2) / 10)];
    var i = Math.floor(Math.floor(Math.log(total) / Math.log(1024)));
    if (i === 0)
        return "".concat(total, " ").concat(suffix, ")");
    return "".concat((total / Math.pow(1024, i)).toFixed(2), " ").concat(suffix);
};
var mapStateToProps = function (state) { return ({
    location: state.fileUploadModal.baseUrl,
    modalState: state.fileUploadModal.modalState,
    files: state.fileUploadModal.files,
    uploadedFiles: state.fileUploadModal.uploadedFiles,
    currentUploadStatus: state.fileUploadModal.currentUploadStatus
}); };
var mapDispatchToProps = function (dispatch) { return ({
    toggleModalStatus: function () {
        dispatch(fileUploadModal_1.default.setFileUploadModalDescription((0, translation_1.getLocalization)('fileUploadModal/description/generic')));
        dispatch(fileUploadModal_1.default.toggleModalStatus());
    },
    addMetadata: function (baseUrl, session) { return function () {
        dispatch(fileUploadModal_1.default.fileuploadDone());
        dispatch((0, connected_react_router_1.push)("".concat(baseUrl, "/metadata/").concat(session)));
    }; }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (this.props.modalState === nextProps.modalState) {
            if (this.props.modalState.isOpen === true ||
                this.props.modalState.showUploadStatusBar === false ||
                this.props.currentUploadStatus === nextProps.currentUploadStatus) {
                return false;
            }
        }
        return true;
    }
}), recompose_1.pure);
var timeout = { exit: 700, enter: 700 };
var classNames = {
    enter: 'bottom-fileupload-bar-enter',
    enterActive: 'bottom-fileupload-bar-enter-active',
    exit: 'bottom-fileupload-bar-exit',
    exitActive: 'bottom-fileupload-bar-exit-active'
};
exports.FileUploadStatusBar = enhance(function (props) { return (React.createElement(react_transition_group_1.TransitionGroup, { classnames: 'bottom-fileupload-bar' }, props.modalState.showUploadStatusBar && !props.modalState.isOpen && (React.createElement(react_transition_group_1.CSSTransition, { timeout: timeout, classNames: classNames },
    React.createElement("div", { className: 'file-upload-status-bar-container' },
        React.createElement("div", { className: 'file-upload-status-bar' },
            React.createElement("div", { className: 'file-upload-status-bar-upload-info' },
                React.createElement("div", { className: 'file-upload-status-bar-upload-info-status' },
                    React.createElement("div", { className: 'loading-spinner' }, props.currentUploadStatus.allDone ? (React.createElement("i", { className: 'fas fa-check completed' })) : (React.createElement("i", { className: 'fas fa-sync-alt fa-spin in-progress' }))),
                    (0, translation_1.getLocalization)('uploadstatusbar/uploading'),
                    ":",
                    utils.currentFile(props.files, props.uploadedFiles),
                    !props.currentUploadStatus.allDone && (React.createElement("span", null,
                        "\u2013",
                        ' ',
                        totalUploadSize(props.currentUploadStatus.totalSize))),
                    React.createElement("span", null, "\u2013"),
                    props.currentUploadStatus.allDone ? (React.createElement("div", { className: 'add-metadata', onClick: props.addMetadata(props.location, props.currentUploadStatus.session) }, (0, translation_1.getLocalization)('uploadstatusbar/addMetadata'))) : (React.createElement("div", { className: 'view-details', onClick: props.toggleModalStatus }, (0, translation_1.getLocalization)('uploadstatusbar/viewDetails')))),
                !props.currentUploadStatus.allDone && (React.createElement("div", { className: 'file-upload-status-bar-upload-info-time-left' },
                    (0, formatSize_1.formatSize)(props.currentUploadStatus.speed),
                    "/s \u2013",
                    ' ',
                    utils.timeRemainingFormat(props.currentUploadStatus.remaining),
                    ' ',
                    (0, translation_1.getLocalization)('uploadstatusbar/time/left')))),
            React.createElement(sok_ui_1.ProgressBar, { showLabel: false, compact: true, percent: props.currentUploadStatus.uploadPercentage }))))))); });
